<template>
  <VChip
    ref="chipRef"
    class="chip mr-1 mb-1"
    size="default"
    @click:close="$emit('click:dismiss', user)"
  >
    {{ userFullName }}
    <template
      v-if="dismissable"
      #close
    >
      <v-icon icon="$close" />
    </template>
  </VChip>
</template>

<script setup lang="ts">
import { VChip } from 'vuetify/components';

const props = defineProps<{
  user: User | UserWithRoles | string
  dismissable?: boolean
}>();
defineEmits(['click:dismiss']);

const chipRef = ref<InstanceType<typeof VChip> | null>(null);
const userRef = toRef(props, 'user');
const userFullName = computed(() => {
  if (typeof userRef.value === 'string') {
    return userRef.value;
  }
  return getUserDisplayName(userRef.value as any as User, false);
});
</script>
